import { useEffect, useState } from 'react'
import { useSocket } from 'providers'
import { useGetQuery, usePostQuery } from 'hooks'

// Shared chat data-fetching for a location's comments. `fetchUrl` is whatever
// endpoint returns `{ location: { addresses: [{ id, comments }] } }` for the
// caller's role (user/host/admin each hit a different, permission-scoped
// endpoint). The real location id (not a route slug) is read back from the
// response so posts and the socket channel always target the right record.
export const useLocationChat = (fetchUrl) => {
  const [comments, setComments] = useState([])
  const socket = useSocket()

  const { data, reFetch } = useGetQuery({ url: fetchUrl })
  const { post: postComment } = usePostQuery({})

  const location = data?.location
  const address = location?.addresses?.[0]

  useEffect(() => {
    setComments(address?.comments || [])
  }, [address])

  useEffect(() => {
    if (!location?.id) return
    const channel = `/locations/${location.id}/comments`
    socket.on(channel, () => {
      setTimeout(() => {
        reFetch(true)
      }, 1000)
    })
  }, [socket, location?.id])

  const send = (comment) => {
    if (!address || !location) return
    postComment(
      {
        comment,
        commentable_type: 'address',
        commentable_id: address.id
      },
      `/locations/${location.id}/comments`
    )
  }

  return { location, comments, send }
}
